import { Component, Input, Optional, Self } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NgControl } from '@angular/forms';


@Component({
  selector: 'uni-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
})
export class UniCheckboxComponent implements ControlValueAccessor {
  private _checked: boolean;

  @Input() public set checked(value: boolean) {
    this._checked = value;
    this._controlValueAccessorChangeFn(value);
  }

  public get checked(): boolean {
    return this._checked;
  }

  @Input() public disabled: boolean;

  @Input() public get required(): boolean {
    const validators = this.ngControl?.control?.validator;
    return this._required ?? validators ? validators({} as AbstractControl)?.hasOwnProperty("required") : false;
  }

  public set required(value: boolean) {
    this._required = value;
  }

  protected _required: boolean | undefined;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private _onTouched: () => void = () => {};
  private _controlValueAccessorChangeFn: (value: any) => void = () => {};

  constructor(@Self() @Optional() private ngControl: NgControl) {
    this.ngControl.valueAccessor = this;
  }
  
  public writeValue(checked: boolean): void {
    this.checked = checked;
  }
  public registerOnChange(fn: (value: any)=> void): void {
    this._controlValueAccessorChangeFn = fn;
  }

  public registerOnTouched(fn: ()=> void): void {
    this._onTouched = fn;
  }

  public setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  public onCheckboxChange(): void {
    this.checked = !this.checked;
    this._controlValueAccessorChangeFn(this.checked);
    this._onTouched();
  }

}
